import semver from "semver";
import URI from 'urijs';

import config from '../config';
import { deviceDetection } from '../helpers/DeviceDetection';
import { standardizeVersion } from '../helpers/InAppHelpers';
import { fetcher } from '../lib/APIClient';
import InAppStore from '../stores/InAppStore';

const AppNotifyService = {

    notify (path, query = {}) {
        // new app
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                source: 'otrl',
                event: path,
                data: query
            }));
            return Promise.resolve();
        }

        // Old app
        const url = URI.build({
            protocol: 'https',
            hostname: 'otrl',
            path,
            query: URI.buildQuery(query, false, false)
        });

        return fetcher(url, { loader: false })
                .catch(() => {
                    const hasAppSupport = InAppStore.getAppVersion() && semver.satisfies(standardizeVersion(InAppStore.getAppVersion()), config.get('gaAjaxHandlerAppVersion'));
                    const isIOS = deviceDetection() === 'iOS';
                    if (InAppStore.isInApp() && hasAppSupport && isIOS) {
                        // The iOS version of the app requires that all custom queries
                        // starts with gaajaxhandler:// custom scheme.
                        window.location = 'gaajaxhandler://' + url;
                    }
                });
    }

};

export default AppNotifyService;
